import type { ConstsConfig } from '../declare'

const consts: ConstsConfig[] = [
  // 默认弹窗宽度
  {
    name: 'MODAL_DEFAULT_WIDTH',
    value: '45%'
  },
  // 默认弹窗最大宽度
  {
    name: 'MODAL_DEFAULT_MAX_WIDTH',
    value: 1600
  },
]

export default consts